<mat-dialog-content>
    <img [src]="data.imageUrl" />
</mat-dialog-content>
